import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Card, Table, Input, Button, Select, Row, Col,
} from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faMicrochip } from '@fortawesome/free-solid-svg-icons';

import {
  ResponsiveContainer,
} from 'recharts';
import { useTranslation } from 'react-i18next';

import useDeviceListTable from './useDeviceListTable';
import styles from './DeviceListTable.module.less';

const style = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 25,
  marginTop: 25,
  cursor: 'pointer',
};

function DeviceListTable({ className }) {

  const { t } = useTranslation();
  const {
    loading,
    pagination,
    columns,
    // devices,
    arrayFilter,
    setValueFilter,
    // onChangeSearch,
    handleTableChange,
    setStatusDevices,
    createDevice,
    goToDeviceId,
    isCreate,
  } = useDeviceListTable();
  const [plantilla, setPlantilla] = useState('1'); 
  const handleChangePlantilla = (value) => { 
    setPlantilla(value); 
  };

  useEffect(
    () => {

      handleTableChange(
        {
          current: 1,
          pageSize: 20,
        },
        null,
        null,
      );

    },
    // eslint-disable-next-line
    []
  );
 

  return (
    <Col span={24}>
      <Row>
        <Card className={className}>
          <ResponsiveContainer width="100%">
            <div className={styles.tables}>
              <Row className={styles.headerTables} gutter={[8, 8]}>

                <Col  xs={{span: 24,order: 1,  }}  sm={{span: 24,order: 1,  }}  md={{span: 8,order: 2,  }}  lg={{span: 8,order: 2,  }}  xl={{ span: 8, order: 2,  }}
                >
                  <Input
                    placeholder={t('common.find')}
                    className={styles.search}
                    onChange={(e) => setValueFilter(e.target.value)}
                    // onChange={onChangeSearch}
                    suffix={<FontAwesomeIcon icon={faSearch} />}
                    allowClear
                  />
                </Col> 

                <Col
                  className="select-filter" 
                  xs={{span: 24,order: 2, }} sm={{span: 24,order: 2, }} md={{span: 6,order: 3, }} lg={{span: 6,order: 3, }} xl={{span: 6,order: 3, }}
                >
                  <Select
                    defaultValue="todos"
                    className={styles.select_device}
                    onChange={setStatusDevices}
                    options={[
                      {
                        value: 'todos',
                        label: t('common.show_all'),
                      },
                      {
                        value: 'conectados',
                        label: t('common.connected'),
                      },
                      {
                        value: 'desconectados',
                        label: t('common.disconnected'),
                      },
                    ]}
                  />
                </Col>


                <Col
                  className="select-filter"  xs={{span: 24,order: 2,  }}  sm={{span: 24,order: 2,  }}  md={{span: 6,order: 3,  }}  lg={{span: 6,order: 3,  }}  xl={{span: 6,order: 3,  }}
                >
                  <Select
                    defaultValue="1"
                    className={styles.select_device}
                    onChange={handleChangePlantilla}
                    options={[
                      {
                        value: '1',
                        label: t('common.individual_devices'),
                      },
                      {
                        value: '2',
                        label: t('common.grouped_templates'),
                      },
                    ]}
                  />
                </Col>
                
                {
                  isCreate &&
                  <Col  xs={{span: 24,order: 4,  }}  sm={{span: 24,order: 4,  }}  md={{span: 4,order: 4,  }}  lg={{span: 4,order: 4,  }}  xl={{span: 4, order: 4,  }}
                  >
                    <Button type="primary" className={styles.btn_create} onClick={createDevice}>
                      {t('views.create_devices.new_device')}
                    </Button>
                  </Col> 
                }
                
              </Row>
            </div>
          </ResponsiveContainer>
        </Card>
      </Row>

      {plantilla === '1' && (
        <Card className={className}>
          <ResponsiveContainer width="100%">
            <div className={styles.tables}>
              <Table
                className={styles.table}
                loading={loading}
                columns={columns}
                dataSource={arrayFilter}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey={(record) => record.id}
              />
            </div>
          </ResponsiveContainer>
        </Card>
      )}

      {plantilla === '2' && (
        <Row>
          {arrayFilter.map((item, i) => (
            <Col key={i} xs={24} sm={16} md={12} lg={8} xl={6}>
              <div style={style} onClick={() => goToDeviceId(item)}>
                <Card style={{ width: '90%' }}>
                  <div style={{
                    fontSize: 20, fontWeight: 'bold', marginBottom: 10, color: '#000000',
                  }}
                  >
                    <FontAwesomeIcon
                      icon={faMicrochip}
                      style={{ fontSize: 24, color: '#787878', marginRight: '1rem' }}
                    />
                    <span>{item?.name}</span>
                  </div>
                  <div>
                    {/* <p style={{ minHeight: '44px', color: '#8c8c8c' }}>{item.description}</p> */}
                    <div style={{ borderRadius: 10 }}>
                      <Row>
                        <Col span={24}>
                          <ul className={styles.list}>

                            <li style={{ marginBottom: 5, color: '#8c8c8c', fontSize: 12 }}>
                              {t('common.clients')}
                              <span
                                style={{ fontSize: 12, float: 'right', color: '#000000' }}
                              >
                                {item?.client}
                              </span>
                            </li>

                            <li style={{ marginBottom: 5, color: '#8c8c8c', fontSize: 12 }}>
                              {t('common.device_types_name')}
                              <span
                                style={{ fontSize: 12, float: 'right', color: '#000000' }}
                              >
                                {item?.device_types_name}
                              </span>
                            </li>

                            <li style={{ marginBottom: 5, color: '#8c8c8c', fontSize: 12 }}>
                              {t('tables.devices.columns.slvdl')}
                              <span
                                style={{ fontSize: 12, float: 'right', color: '#000000' }}
                              >
                                {item?.slvId}
                              </span>
                            </li>

                            <li style={{ marginBottom: 5, color: '#8c8c8c', fontSize: 12 }}>
                              {t('tables.devices.columns.gateway')}
                              <span
                                style={{ fontSize: 12, float: 'right', color: '#000000' }}
                              >
                                {item?.gateway?.name}
                              </span>
                            </li>

                          </ul>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      )}

    </Col>
  );

}

DeviceListTable.propTypes = {
  className: PropTypes.string,
};

DeviceListTable.defaultProps = {
  className: null,
};

export default DeviceListTable;
